// Same-origin client for POST /api/native-ui-block-generate.
// Request body is exactly `{ prompt: string }` — the route rejects any other
// contract (native-ui-block-generate.ts body gate). The shared-key header is
// NOT sent from the browser; the vite appliance/e2e plugin injects it from
// process.env so the key never enters the client bundle.

export const NATIVE_UI_BLOCK_GENERATE_PATH = '/api/native-ui-block-generate'

function readRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {}
}

export interface NativeUiBlockGenerateResponse {
  httpStatus: number
  body: Record<string, unknown>
}

export async function postNativeUiBlockGenerate(
  prompt: string,
): Promise<NativeUiBlockGenerateResponse> {
  const response = await fetch(NATIVE_UI_BLOCK_GENERATE_PATH, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt }),
  })
  let parsed: unknown = {}
  try {
    parsed = await response.json()
  } catch {
    parsed = {}
  }
  return { httpStatus: response.status, body: readRecord(parsed) }
}
